var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.paymentFailure ? _c("plan-message") : _vm._e(),
      _vm._v(" "),
      _c("plan-boxes", { attrs: { "with-session": "" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }